import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { VolunteerSignupMentor } from '@interfaces';
import { AppService } from '../../../../../../services';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(service: VolunteeringAreaService, util: UtilityService, dialogService: DialogService, app: AppService): GridSetup<VolunteerSignupMentor> {

	return {
		rowName: { singular: 'Accepted Sign Ups', plural: 'Accepted Sign Ups' },
		getRowKey: row => '' + row.volunteerSignupMentorId,
		stateKey: 'accepted-mentor-sign-ups-grid',
		actions: getActions(service, dialogService),
		buttons: [],
		columns: getColumns(util, app),
	}
}
